import { useCallback, useEffect, useState } from "react";

function useLoadBasedSubmissionDetection(validator, onDismiss) {
  const [loadCount, setLoadCount] = useState(0);

  const updateLoadCount = useCallback(() => {
    setLoadCount((prevCount) => {
      return prevCount + 1;
    });
  }, []);

  useEffect(() => {
    if (validator) return;

    if (loadCount > 1) onDismiss();
  }, [loadCount, validator, onDismiss]);

  return { updateLoadCount };
}

export default useLoadBasedSubmissionDetection;
